export default __webpack_public_path__ + "empty-merge-requests-md.83c3b841.svg";